"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  LaptopLaunch: ['laptop-launch', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,14.87A1.668,1.668,0,0,0,10.281,16.6a5.705,5.705,0,0,0,1.53,2.939.249.249,0,0,0,.189.086.253.253,0,0,0,.189-.085,5.713,5.713,0,0,0,1.53-2.94A1.668,1.668,0,0,0,12,14.87Z', 'M10.521,13.7h2.961l1.439.914a.5.5,0,0,0,.768-.407l.041-1.4a2,2,0,0,0-1.283-1.925l-.114-.044a.25.25,0,0,1-.155-.287l1-4.514a3.09,3.09,0,0,0-1.057-2.644c-.213-.169-.614-.464-1.011-.749a.252.252,0,0,1-.1-.2V1.25a1,1,0,0,0-2,0V2.442a.25.25,0,0,1-.1.2c-.4.286-.8.58-1.011.749A3.093,3.093,0,0,0,8.829,6.038l1,4.512a.251.251,0,0,1-.154.288l-.118.045a2,2,0,0,0-1.282,1.925l.04,1.4a.5.5,0,0,0,.768.407ZM12,7.1a1.137,1.137,0,1,1,1.137-1.137A1.137,1.137,0,0,1,12,7.1Z', 'M5.249,7.048a2,2,0,0,0-2,2v9.5a.25.25,0,0,1-.057.159L.378,22.129A1.148,1.148,0,0,0,1.461,23.75H22.539a1.148,1.148,0,0,0,1.083-1.621l-2.814-3.42a.25.25,0,0,1-.057-.159v-9.5a2,2,0,0,0-2-2h-1.5a1,1,0,0,0,0,2H18.5a.25.25,0,0,1,.25.25v8.8a.25.25,0,0,1-.25.25h-3.56a.249.249,0,0,0-.224.14,9.981,9.981,0,0,1-1.632,2.3,1.5,1.5,0,0,1-2.17,0,9.981,9.981,0,0,1-1.632-2.3.249.249,0,0,0-.224-.14H5.5a.25.25,0,0,1-.25-.25V9.3a.25.25,0,0,1,.25-.25h1.25a1,1,0,1,0,0-2Z']],
  LaunchGoFlag: ['launch-go-flag', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.52,5.28a1.2,1.2,0,0,0-1.2,1.2v3.84a1.2,1.2,0,1,0,2.4,0V6.48A1.2,1.2,0,0,0,17.52,5.28Z', 'M6,1.44a.96.96,0,0,0-.96.96V14.88a.96.96,0,0,0,.96.96H22.32a.96.96,0,0,0,.96-.96V2.4a.96.96,0,0,0-.96-.96Zm4.8,10.321a1.2,1.2,0,0,0,1.2-1.2.24.24,0,0,0-.24-.241h-.48a.72.72,0,1,1,0-1.44h1.44a.721.721,0,0,1,.72.721v.96a2.64,2.64,0,0,1-5.28,0V6.721a2.64,2.64,0,1,1,5.28,0,.72.72,0,0,1-1.44,0,1.2,1.2,0,1,0-2.4,0v3.84A1.2,1.2,0,0,0,10.8,11.761Zm9.36-1.441a2.64,2.64,0,0,1-5.28,0V6.48a2.64,2.64,0,0,1,5.28,0Z', 'M2.16,0A1.441,1.441,0,0,0,.72,1.44V22.561a1.44,1.44,0,0,0,2.88,0V1.44A1.44,1.44,0,0,0,2.16,0Z']],
  LaunchGo: ['launch-go', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.36,12.96a1.2,1.2,0,0,0,1.2-1.2V7.92a1.2,1.2,0,0,0-2.4,0v3.841A1.2,1.2,0,0,0,15.36,12.96Z', 'M1.44,24a1.44,1.44,0,0,0,1.44-1.439V17.53a.251.251,0,0,1,.25-.25H20.87a.251.251,0,0,1,.25.25v5.031a1.44,1.44,0,0,0,2.88,0V1.44a1.44,1.44,0,0,0-2.88,0V2.63a.249.249,0,0,1-.25.25H3.13a.249.249,0,0,1-.25-.25V1.44A1.44,1.44,0,0,0,0,1.44V22.561A1.44,1.44,0,0,0,1.44,24ZM12.72,7.92a2.64,2.64,0,0,1,5.28,0v3.841a2.64,2.64,0,0,1-5.28,0ZM6,8.16a2.64,2.64,0,0,1,5.28,0,.72.72,0,0,1-1.44,0,1.2,1.2,0,1,0-2.4,0V12a1.2,1.2,0,1,0,2.4,0,.239.239,0,0,0-.24-.239H9.12a.721.721,0,0,1,0-1.441h1.44a.721.721,0,0,1,.72.72V12A2.64,2.64,0,1,1,6,12Z']],
  StartupLaunch1: ['startup-launch-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.013,15.854h1.7a1,1,0,0,0,.184-1.983.25.25,0,0,1-.2-.2,1,1,0,0,0-1.983.183v.018a.015.015,0,0,1-.013.015,2.3,2.3,0,0,0-.962,4.186l1.84,1.227a.3.3,0,0,1-.168.554h-1.7a1,1,0,0,0-.184,1.984.25.25,0,0,1,.2.2A1,1,0,0,0,21.7,22a.25.25,0,0,1,.2-.207,2.295,2.295,0,0,0,.793-4.156l-1.84-1.227a.3.3,0,0,1,.168-.555Z', 'M2.987,8.146H1.29a1,1,0,0,0-.183,1.983.252.252,0,0,1,.2.2,1,1,0,0,0,1.97-.039.249.249,0,0,1,.195-.207,2.295,2.295,0,0,0,.793-4.156L2.425,4.7a.3.3,0,0,1,.168-.555h1.7a1,1,0,0,0,.184-1.983.252.252,0,0,1-.2-.2,1,1,0,0,0-1.983.183v.017a.016.016,0,0,1-.013.016,2.3,2.3,0,0,0-.962,4.186l1.84,1.227a.3.3,0,0,1-.168.554Z', 'M3.786,18.038c-1.052,1.052-1.29,3.5-1.341,4.329a.251.251,0,0,0,.265.266c.827-.051,3.278-.289,4.33-1.341a2.233,2.233,0,0,0,.011-3.265,2.472,2.472,0,0,0-1.671-.711A2.22,2.22,0,0,0,3.786,18.038Z', 'M8.725,12.034l-.217-.1a2.679,2.679,0,0,0-3.036.608l-1.29,1.367a.669.669,0,0,0,.341,1.112l2.227.5h0l0,.006,2.8,2.8h0l.5,2.228a.669.669,0,0,0,1.112.341l1.367-1.291a2.676,2.676,0,0,0,.609-3.035l-.1-.216a.251.251,0,0,1,.094-.313l5.272-3.365.009-.006a4.142,4.142,0,0,0,1.5-3.5c-.051-.447-.2-1.349-.323-2.118a.251.251,0,0,1,.07-.219l.624-.624A1,1,0,0,0,18.873,4.8l-.624.624a.249.249,0,0,1-.218.069c-.771-.128-1.671-.272-2.119-.322a4.144,4.144,0,0,0-3.5,1.5l-.006.01L9.037,11.94A.248.248,0,0,1,8.725,12.034Zm5.686-3.515a1.522,1.522,0,1,1,0,2.152A1.522,1.522,0,0,1,14.411,8.519Z']],
  StartupLaunch: ['startup-launch', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M1.5,23.5A.5.5,0,0,0,2,24H20.5a.5.5,0,0,0,.5-.5,2.926,2.926,0,0,0-2.781-2.992.25.25,0,0,1-.231-.22A2.353,2.353,0,0,0,15.5,18.5h-.8a.251.251,0,0,0-.238.173,10.083,10.083,0,0,1-2.13,3.362,1.5,1.5,0,0,1-2.17,0,10.083,10.083,0,0,1-2.13-3.362A.251.251,0,0,0,7.8,18.5H7a2.362,2.362,0,0,0-2.479,1.8.251.251,0,0,1-.231.212A2.927,2.927,0,0,0,1.5,23.5Z', 'M11.25,15.478a1.887,1.887,0,0,0-1.945,1.958c0,1.231,1.268,2.8,1.757,3.356a.25.25,0,0,0,.376,0c.488-.557,1.757-2.124,1.757-3.356A1.887,1.887,0,0,0,11.25,15.478Z', 'M13.646,2.492a8.071,8.071,0,0,0-1.272-.721.25.25,0,0,1-.136-.273.735.735,0,0,0,.014-.142V1a1,1,0,0,0-2,0v.356a.735.735,0,0,0,.014.142.25.25,0,0,1-.136.273,8.009,8.009,0,0,0-1.271.721,3.5,3.5,0,0,0-1.2,2.987l0,.01,1.128,5.13a.251.251,0,0,1-.155.287l-.156.06A2.263,2.263,0,0,0,7.03,13.145c.08,2.774.087,2.575,2.543,1.015v0l0,0h3.35l1.628,1.035a.566.566,0,0,0,.869-.462l.046-1.587a2.264,2.264,0,0,0-1.451-2.179l-.156-.06a.25.25,0,0,1-.154-.287c.069-.314,1.051-4.827,1.135-5.14A3.5,3.5,0,0,0,13.646,2.492ZM11.252,6.68a1.287,1.287,0,1,1,1.287-1.286A1.286,1.286,0,0,1,11.252,6.68Z', 'M21.3,12H23a1,1,0,0,0,.184-1.982.253.253,0,0,1-.2-.2A1,1,0,0,0,21,10v.018a.016.016,0,0,1-.013.015,2.3,2.3,0,0,0-.962,4.186l1.84,1.226A.3.3,0,0,1,21.7,16H20a1,1,0,0,0-.183,1.983.252.252,0,0,1,.2.2,1,1,0,0,0,1.97-.039.25.25,0,0,1,.2-.207,2.3,2.3,0,0,0,.793-4.157l-1.84-1.226A.3.3,0,0,1,21.3,12Z', 'M2.7,7H1A1,1,0,0,0,.817,8.983a.252.252,0,0,1,.2.2,1,1,0,0,0,1.97-.039.25.25,0,0,1,.195-.207,2.3,2.3,0,0,0,.793-4.157L2.135,3.555A.3.3,0,0,1,2.3,3H4a1,1,0,0,0,.184-1.982.253.253,0,0,1-.2-.2A1,1,0,0,0,2,1v.018a.016.016,0,0,1-.013.015,2.3,2.3,0,0,0-.962,4.186l1.84,1.226A.3.3,0,0,1,2.7,7Z']],
  MobileLaunch: ['mobile-launch', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.582,1.7A1,1,0,0,0,20.168.287l-.946.947A.251.251,0,0,1,19,1.3c-.482-.079-.974-.156-1.244-.186A3.091,3.091,0,0,0,15.143,2.24L12.656,6.135a.25.25,0,0,1-.312.094l-.116-.051a2,2,0,0,0-2.268.454L9,7.653a.5.5,0,0,0,.254.831l1.668.372h0l2.093,2.094h0l.371,1.664a.5.5,0,0,0,.832.255l1.021-.964a2,2,0,0,0,.454-2.267l-.05-.113a.25.25,0,0,1,.094-.312l3.9-2.487a3.092,3.092,0,0,0,1.121-2.618c-.03-.269-.107-.761-.185-1.244a.252.252,0,0,1,.069-.217Zm-3.336,3.53a1.137,1.137,0,1,1,0-1.608A1.137,1.137,0,0,1,18.246,5.231Z', 'M7.482,14.481a4.412,4.412,0,0,0,3.346-.91,1.681,1.681,0,0,0,0-2.662,1.681,1.681,0,0,0-2.662,0,4.425,4.425,0,0,0-.911,3.347A.248.248,0,0,0,7.482,14.481Z', 'M12.125,3.007V.507a.5.5,0,0,0-.5-.5h-7a2.5,2.5,0,0,0-2.5,2.5v19a2.5,2.5,0,0,0,2.5,2.5h9a2.5,2.5,0,0,0,2.5-2.5v-5.5a1,1,0,0,0-2,0v2a.5.5,0,0,1-.5.5h-9a.5.5,0,0,1-.5-.5v-14a.5.5,0,0,1,.5-.5h7A.5.5,0,0,0,12.125,3.007Zm-3,17.5a1,1,0,1,1-1,1A1,1,0,0,1,9.125,20.508Z']]
};
exports["default"] = _default;